import { isFunction } from 'lodash';
export function isComponentValueCache(target) {
    return target instanceof ComponentValueCache;
}
export class ComponentValueCache {
    attr;
    component;
    storageKey;
    unwatch;
    constructor(component, attr, storageKey) {
        this.attr = attr;
        this.component = component;
        this.storageKey = storageKey;
        component.$once('hook:mounted', () => this.registerWatcher());
        component.$once('hook:beforeDestroy', () => this.unsubscribeWatcher());
    }
    get effectiveStorageKey() {
        return isFunction(this.storageKey)
            ? this.storageKey.call(this.component)
            : this.storageKey;
    }
    getValue() {
        return this.component.$app.objectStore.get(this.effectiveStorageKey);
    }
    registerWatcher() {
        this.unwatch = this.component.$watch(this.attr, (v, o) => this.onValueChange(v, o), {
            deep: true
        });
    }
    unsubscribeWatcher() {
        if (this.unwatch) {
            this.unwatch();
        }
    }
    onValueChange(value, oldValue) {
        this.persist(value);
    }
    async persist(value) {
        const k = this.effectiveStorageKey;
        if (k != null) {
            this.component.$app.objectStore.set(this.effectiveStorageKey, value);
        }
    }
    async clearCache() {
        this.component.$app.objectStore.set(this.effectiveStorageKey, null);
    }
}
//# sourceMappingURL=caching.js.map